export default "__VITE_ASSET__Dgj_5Zev__"